// import axios from "axios";
// import { NetworkInfo } from "../constants/network.ts"; 
// // import {toast} from 'react-toastify'

// const getHeader = () => {
//   const storedUser = localStorage.getItem("usmonUser");
//   const accessToken = storedUser ? JSON.parse(storedUser)?.access_token : null;
//   return accessToken ?  { Authorization: `Bearer ${accessToken}` } : {};
  
// };

// export default class Http {
//   static get(url, params) {
//     return new Promise((resolve, reject) => {
//       let headers = getHeader();
//       axios({
//         method: "get",
//         url: `${NetworkInfo?.baseURL}/${url}`,
//         headers: headers,
//         params: params,
//         //withCredentials: true,
//         // Include this line
//       })
//         .then(function (response) {
//           resolve(response.data);
//         })
//         .catch(function (error) {
//           console.log("error in https  file",error );
//           if(error?.status==401){
//             localStorage.clear();
//             window.location.replace('/')
//             // toast.error("Token expired")
//           }else{
//             reject(error);
//           }
//         });
//     });
//   }
//   static post(url, body) {
//     return new Promise((resolve, reject) => {
//       let headers = getHeader();
//       const parts = url.split("/"); 
//       const lastPart = parts[parts.length - 1]; 
//       axios({
//         method: "post",
//         url: `${NetworkInfo?.baseURL}/${url}`,
//         data: body,
//         headers: lastPart=='login' ? {  }: headers,
//         //withCredentials: true, // Include this line
//       })
//         .then(function (response) {
//           resolve(response.data);
//         })
//         .catch(function (error) {
//           if(error?.status==401){
//             if(lastPart=='login'){
//               resolve(error?.response);
//             }else{
//               localStorage.clear();
//               window.location.replace('/')
//             }
//           }else{
//             reject(error);
//           }
//         });
//     });
//   }

  

//   static postnobody(url) {
//     return new Promise(async (resolve, reject) => {
//       let token = getHeader();
//       axios({
//         method: "post",
//         url: `${NetworkInfo?.baseURL}/${url}`,
//         headers: token,
//         //withCredentials: true,
//       })
//         .then(function (response) {
//           resolve(response.data);
//         })
//         .catch(function (error) {
//           console.log(error, "error");
//           if(error?.status==401){
//             localStorage.clear();
//             window.location.replace('/')
//             // toast.error("Token expired")
//           }else{
//             reject(error);
//           }
//         });
//     });
//   }
//   static postrequestmultipart(url, body) {
//     return new Promise(async (resolve, reject) => {
//       const storedUser = localStorage.getItem("usmonUser");
//       const accessToken = storedUser ? JSON.parse(storedUser)?.access_token : null;
//       axios({
//         method: "post",
//         url: `${NetworkInfo?.baseURL}/${url}`,
//         data: body,
//         headers: {
//           Authorization: `Bearer ${accessToken}`,
//           contentType: "multipart/form-data",
//         },
//         //withCredentials: true,
//       })
//         .then(function (response) {
//           resolve(response.data);
//         })
//         .catch(function (error) {
//           console.log(error, "error");
//           if(error?.status==401){
//             localStorage.clear();
//             window.location.replace('/')
//             // toast.error("Token expired")
//           }else{
//             reject(error);
//           }
//         });
//     });
//   }
//   static put(url, body) {
//     return new Promise((resolve, reject) => {
//       let token = getHeader();
//       axios({
//         method: "put",
//         url: `${NetworkInfo?.baseURL}/${url}`,
//         data: body,
//         headers: token,
//          //withCredentials: true,
//       })
//         .then(function (response) {
//           if (response.data && response.data.success) {
//             resolve(response.data);
//           } else {
//             reject(response.data);
//           }
//         })
//         .catch(function (error) {
//           console.log(error, "error");
//           if(error?.status==401){
//             localStorage.clear();
//             window.location.replace('/')
//             // toast.error("Token expired")
//           }else{
//             reject(error);
//           }
//         });
//     });
//   }
//   static delete(url, params) {
//     return new Promise((resolve, reject) => {
//       let token = getHeader();
//       axios({
//         method: "delete",
//         url: `${NetworkInfo?.baseURL}/${url}`,
//         headers: token,
//         params: params,
//         // withCredentials: true,
//       })
//         .then(function (response) {
//           if (response.data && response.data.success) {
//             resolve(response.data);
//           } else {
//             reject(response.data);
//           }
//         })
//         .catch(function (error) {
//           console.log(error, "error");
//           if(error?.status==401){
//             localStorage.clear();
//             window.location.replace('/')
//             // toast.error("Token expired")
//           }else{
//             reject(error);
//           }
//         });
//     });
//   }
//   static deletewithbody(url, body) {
//     return new Promise((resolve, reject) => {
//       let token = getHeader();
//       axios({
//         method: "delete",
//         url: `${NetworkInfo?.baseURL}/${url}`,
//         data: body,
//         headers: token,
//         // withCredentials: true, 
//       })
//         .then(function (response) {
//           if (response.data && response.data.success) {
//             resolve(response.data);
//           } else {
//             reject(response.data);
//           }
//         })
//         .catch(function (error) {
//           console.log(error, "error");
//           if(error?.status==401){
//             localStorage.clear();
//             window.location.replace('/')
//             // toast.error("Token expired")
//          }else{
//            reject(error);
//          }
//         });
//     });
//   }
// }



import axios from "axios";
import { NetworkInfo } from "../constants/network.ts";

const getHeader = () => {
  const storedUser = localStorage.getItem("usmonUser");
  const accessToken = storedUser ? JSON.parse(storedUser)?.access_token : null;
  return accessToken ? { Authorization: `Bearer ${accessToken}` } : {};
};

const refreshToken = async () => {
  const storedUser:any = localStorage.getItem("usmonUser");
  const refreshToken = storedUser ? JSON.parse(storedUser)?.refresh_token : null;

  if (!refreshToken) {
    if ("credentials" in localStorage) {
      localStorage.removeItem("usmonCatalog");
      localStorage.removeItem("usmonUser")
  } else {
      localStorage.clear();
  }
    window.location.replace("/");
    return null;
  }

  try {
    let token=getHeader()
    const response=await axios({
      method: "post",
      url: `${NetworkInfo?.baseAuthURL}/${NetworkInfo.endpoints.auth}${NetworkInfo.endpoints.refreshToken}`,
      data: {refresh_token: refreshToken},
      headers: token,
      // withCredentials: true,
    })
    if (response?.data?.data?.access_token) {
      const updatedUser = {
        ...JSON.parse(storedUser),
        access_token: response?.data?.data?.access_token,
        refresh_token: response?.data?.data?.refresh_token || refreshToken,
      };
      localStorage.setItem("usmonUser", JSON.stringify(updatedUser));
      return response?.data?.data?.access_token;
    }
  } catch (error) {
    if ("credentials" in localStorage) {
      localStorage.removeItem("usmonCatalog");
      localStorage.removeItem("usmonUser")
  } else {
      localStorage.clear();
  }
    window.location.replace("/");
    return null;
  }
};

// **Axios Interceptor for Token Refresh**
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const newToken = await refreshToken();

      if (newToken) {
        originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
        return axios(originalRequest); // Retry original request
      }
    }

    return Promise.reject(error);
  }
);

export default class Http {
  static async get(url, params) {
    try {
      let headers = getHeader();
      const response = await axios.get(`${NetworkInfo?.baseURL}/${url}`, {
        headers,
        params,
      });
      return response?.data;
    } catch (error: any) {
      
      if (error.response?.status === 401) {
        const newToken = await refreshToken();
        if (newToken) {
          let newHeaders = { Authorization: `Bearer ${newToken}` };
          const retryResponse = await axios.get(`${NetworkInfo?.baseURL}/${url}`, {
            headers: newHeaders,
            params,
          });
          return retryResponse.data;
        }
      } else if(error?.response?.data?.message==='Token is invalid or revoked' && error?.response?.data?.statusCode===400){
        if ("credentials" in localStorage) {
          localStorage.removeItem("usmonCatalog");
          localStorage.removeItem("usmonUser")
      } else {
          localStorage.clear();
      }
        window.location.replace("/");
        return null;
      }
      return Promise.reject(error);
    }
  }

  static async post(url, body) {
    let headers = getHeader();
    const parts = url.split("/");
    const lastPart = parts[parts.length - 1];
    const authEndpoints = ["login", "create", "switch-client", "sessions", "logout", "refresh-token", "verify-user"];
    const baseURL = authEndpoints.includes(lastPart) ? NetworkInfo.baseAuthURL : NetworkInfo.baseURL;

    try {
      const response = await axios.post(
        `${baseURL}/${url}`,
        lastPart === "login" ? {} : body,
        { headers: lastPart === "login" ? { Authorization: `Basic ${body}` } : headers }
      );
      return response?.data;

    } catch (error: any) {
      if (error.response?.status === 401) {
        const newToken = await refreshToken();
        if (newToken) {
          let newHeaders = { Authorization: `Bearer ${newToken}` };
          const retryResponse = await axios.post(
            `${NetworkInfo?.baseURL}/${url}`,
            lastPart === "login" ? {} : body,
            { headers: lastPart === "login" ? { Authorization: `Basic ${body}` } : newHeaders }
          );
          return retryResponse.data;
        }
      } else if(error?.response?.data?.message==='Token is invalid or revoked' && error?.response?.data?.statusCode===400){
        if ("credentials" in localStorage) {
          localStorage.removeItem("usmonCatalog");
          localStorage.removeItem("usmonUser")
      } else {
          localStorage.clear();
      }
        window.location.replace("/");
        return null;
      }
      return Promise.reject(error);
    }
  }

  static async postnobody(url) {
    try {
      let token = getHeader();
      const response = await axios({
        method: "post",
        url: `${NetworkInfo?.baseURL}/${url}`,
        headers: token,
        //withCredentials: true,
      })
      return response?.data;
    } catch (error: any) {
      if (error.response?.status === 401) {
        const newToken = await refreshToken();
        if (newToken) {
          let newHeaders = { Authorization: `Bearer ${newToken}` };
          const retryResponse = await axios({
            method: "post",
            url: `${NetworkInfo?.baseURL}/${url}`,
            headers:newHeaders,
            //withCredentials: true,
          })
          return retryResponse.data; // returning data after retry
        }
      } else if(error?.response?.data?.message==='Token is invalid or revoked' && error?.response?.data?.statusCode===400){
        if ("credentials" in localStorage) {
          localStorage.removeItem("usmonCatalog");
          localStorage.removeItem("usmonUser") 
      } else {
          localStorage.clear();
      }
        window.location.replace("/");
        return null;
      }
      return Promise.reject(error);
    }
  }

  static async postrequestmultipart(url,body){
    try {
      const storedUser = localStorage.getItem("usmonUser");
      const accessToken = storedUser
        ? JSON.parse(storedUser)?.access_token
        : null;
      const response=await axios({
        method: "post",
        url: `${NetworkInfo?.baseURL}/${url}`,
        data: body,
        headers: {
          Authorization: `Bearer ${accessToken}`,
          contentType: "multipart/form-data",
        },
        //withCredentials: true,
      })
      return response?.data;
    } catch (error: any) {
      if (error.response?.status === 401) {
        const newToken = await refreshToken();
        if (newToken) {
          let newHeaders = { Authorization: `Bearer ${newToken}`,contentType: "multipart/form-data", };
          const retryResponse = await axios({
            method: "post",
            url: `${NetworkInfo?.baseURL}/${url}`,
            data: body,
            headers:newHeaders
            //withCredentials: true,
          })
          return retryResponse.data; // returning data after retry
        }
      } else if(error?.response?.data?.message==='Token is invalid or revoked' && error?.response?.data?.statusCode===400){
        if ("credentials" in localStorage) {
          localStorage.removeItem("usmonCatalog");
          localStorage.removeItem("usmonUser")
      } else {
          localStorage.clear();
      }
        window.location.replace("/");
        return null;
      }
      return Promise.reject(error);
    }
  }
  
  
  static async put(url, body) {
    try {
      let token = getHeader();
      const response=await axios({
        method: "put",
        url: `${NetworkInfo?.baseURL}/${url}`,
        data: body,
        headers: token,
        //withCredentials: true,
      })
      return response?.data;
    } catch (error: any) {
      
      if (error.response?.status === 401) {
        const newToken = await refreshToken();
        if (newToken) {
          let newHeaders = { Authorization: `Bearer ${newToken}` };
          const retryResponse = await axios({
            method: "put",
            url: `${NetworkInfo?.baseURL}/${url}`,
            data: body,
            headers: newHeaders,
            //withCredentials: true,
          })
          return retryResponse.data;
        }
      } else if(error?.response?.data?.message==='Token is invalid or revoked' && error?.response?.data?.statusCode===400){
        if ("credentials" in localStorage) {
          localStorage.removeItem("usmonCatalog");
          localStorage.removeItem("usmonUser")
      } else {
          localStorage.clear();
      }
        window.location.replace("/");
        return null;
      }
      return Promise.reject(error);
    }
  }

    
  static async delete(url, params) {
    try {
      let token = getHeader();
      const response=await axios({
        method: "delete",
        url: `${NetworkInfo?.baseURL}/${url}`,
        headers: token,
        params: params,
        // withCredentials: true,
      })
      return response?.data;
    } catch (error: any) {
      
      if (error.response?.status === 401) {
        const newToken = await refreshToken();
        if (newToken) {
          let newHeaders = { Authorization: `Bearer ${newToken}` };
          const retryResponse = await axios({
            method: "delete",
            url: `${NetworkInfo?.baseURL}/${url}`,
            params: params,            
            headers: newHeaders,
            //withCredentials: true,
          })
          return retryResponse.data;
        }
      } else if(error?.response?.data?.message==='Token is invalid or revoked' && error?.response?.data?.statusCode===400){
        if ("credentials" in localStorage) {
          localStorage.removeItem("usmonCatalog");
          localStorage.removeItem("usmonUser")
      } else {
          localStorage.clear();
      }
        window.location.replace("/");
        return null;
      }
      return Promise.reject(error);
    }
  }

  static async deletewithbody(url, body) {
    try {
      let token = getHeader();
      const response=await axios({
        method: "delete",
        url: `${NetworkInfo?.baseURL}/${url}`,
        data: body,
        headers: token,
        // withCredentials: true,
      })
      return response?.data;
    } catch (error: any) {
      
      if (error.response?.status === 401) {
        const newToken = await refreshToken();
        if (newToken) {
          let newHeaders = { Authorization: `Bearer ${newToken}` };
          const retryResponse = await axios({
            method: "delete",
            url: `${NetworkInfo?.baseURL}/${url}`,
            data: body,
            headers: newHeaders,
            // withCredentials: true,
          })
          return retryResponse.data;
        }
      }
      return Promise.reject(error);
    }
  }
}
